.cardFormGroup {
  border: 1px solid var(--ixf-color-separator);

  .header {
    padding: var(--ixf-space-2) var(--ixf-space-4);
    border-bottom: 1px solid var(--ixf-color-separator);
    border-top-left-radius: var(--ixf-border-radius-2);
    border-top-right-radius: var(--ixf-border-radius-2);
    background: var(--ixf-color-neutral-xlt);

    svg {
      height: 16px;
    }
  }
}

.section {
  &:not(:last-child) {
    border-bottom: 1px solid var(--ixf-color-separator);
  }

  .toggleContainer {
    padding: 5px var(--ixf-space-3) 5px var(--ixf-space-4);
  }

  .inputContainer {
    padding: 0 var(--ixf-space-2) var(--ixf-space-2) var(--ixf-space-2);

    &:first-child {
      padding-top: var(--ixf-space-2);
    }
  }
}
